import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import editIcon from "../../../assets/images/Edit.svg";
import viewIcon from "../../../assets/images/View.svg";
import { MuiDataGridStyle } from "../../../theme/App.theme";
import NoRecordsToDisplay from "../../../components/CommonReusableComponent/NoRecordsToDisplay/NoRecordsToDisplay";
import { AuditStatusPill } from "../../AuditMaster/components/AuditMasterDataTable.config";

const AuditReportDataTable_V2 = ({
  Rows,
  GetRowDataOnClickOfAction,
  PageSizeOptions,
  RowsToDisplay,
}) => {
  const Columns = [
    {
      field: "auditId",
      headerName: "Audit Id",
      excelDataField: "auditId",
      excelName: "Audit Id",
      flex: 1,
      sortable: false,
      minWidth: 180,
    },
    {
      field: "auditTypeCategoryName",
      headerName: "Audit Type Category",
      excelDataField: "auditTypeCategoryName",
      excelName: "Audit Type Category",
      sortable: false,
      flex: 1,
      minWidth: 150,
    },
    {
      field: "auditTypeName",
      headerName: "Audit Type",
      excelDataField: "auditTypeName",
      excelName: "Audit Type",
      sortable: false,
      flex: 1,
      minWidth: 120,
    },
    {
      field: "status",
      headerName: "Status",
      excelDataField: "status",
      excelName: "Status",
      sortable: false,
      flex: 1,
      minWidth: 120,
      renderCell: (param) => <AuditStatusPill data={param?.value} />
    },
    {
      field: "branchName",
      headerName: "Branch",
      excelDataField: "branchName",
      excelName: "Branch",
      sortable: false,
      flex: 1,
      minWidth: 120,
    },
    {
      field: "departmentName",
      headerName: "Department",
      excelDataField: "departmentName",
      excelName: "Department",
      sortable: false,
      flex: 1,
      minWidth: 120,
    },
    {
      field: "areaName",
      headerName: "Area",
      excelDataField: "areaName",
      excelName: "Area",
      sortable: false,
      flex: 1,
      minWidth: 150,
    },
    {
      field: "createdByName",
      headerName: "Created By",
      excelDataField: "createdByName",
      excelName: "Created By",
      sortable: false,
      flex: 1,
      minWidth: 120,
    },
    {
      field: "auditorName",
      headerName: "Auditor Name",
      excelDataField: "auditorName",
      excelName: "Auditor Name",
      sortable: false,
      flex: 1,
      minWidth: 120,
    },
    {
      field: "auditeeName",
      headerName: "Auditee Name",
      excelDataField: "auditeeName",
      excelName: "Auditee Name",
      sortable: false,
      flex: 1,
      minWidth: 120,
    },
    {
      field: "readableStartDate",
      headerName: "Start Date",
      excelDataField: "startDate",
      excelName: "Start Date",
      isDate: true,
      sortable: false,
      flex: 1,
      minWidth: 100,
    },
    {
      field: "readableEndDate",
      headerName: "End Date",
      excelDataField: "endDate",
      excelName: "End Date",
      isDate: true,
      sortable: false,
      flex: 1,
      minWidth: 100,
    },
    {
      field: "createdAt",
      headerName: "Created On",
      excelDataField: "createdAtForExcel",
      excelName: "Created On",
      isDate: true,
      sortable: false,
      flex: 1,
      minWidth: 100,
    },
    {
      field: "updatedAt",
      headerName: "Updated On",
      excelDataField: "updatedAtForExcel",
      excelName: "Updated On",
      isDate: true,
      sortable: false,
      flex: 1,
      minWidth: 100,
    },
  ];

  return (
    <React.Fragment>
      <div className="w-100">
        <DataGrid
          columns={Columns}
          rows={Rows}
          slots={{
            noRowsOverlay: NoRecordsToDisplay,
          }}
          pageSizeOptions={PageSizeOptions || [5, 10, 15, 25, 50]}
          initialState={{
            density: "compact",
            pagination: {
              paginationModel: {
                pageSize: RowsToDisplay || 10,
              },
            },
          }}
          disableRowSelectionOnClick
          density="compact"
          className="custom-data-grid"
          sx={MuiDataGridStyle}
        />
      </div>
    </React.Fragment>
  );
};

export default AuditReportDataTable_V2;
